// Imports
import { faLink } from '@fortawesome/pro-solid-svg-icons';
import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import Input from '../../../shareables/foundation/front-end/components/forms/fields/input';
import Radio from '../../../shareables/foundation/front-end/components/forms/fields/radio';
import Textarea from '../../../shareables/foundation/front-end/components/forms/fields/textarea';
import { GetStartResponse } from '../../../shareables/types/api/main/start/get';


// Define the accepted props
interface Props {
	startState: GetStartResponse;
	storybookContainsProtectedContent?: boolean;
}


// Function component
const MigrateCommunity: React.FC<Props> = ({ startState, storybookContainsProtectedContent }) => {
	// Use state
	const [containsProtectedContent, setContainsProtectedContent] = useState(
		startState.migration?.containsProtectedContent === 'YES' || (storybookContainsProtectedContent ?? false)
	);
	
	
	// Return JSX
	return (
		<React.Fragment>
			<Input
				type='url'
				name='url'
				label='Current website URL'
				note='Must include http:// or https://'
				icon={faLink}
				required
				maxLength={2000}
				placeholder='https://www.example.com'
				initialValue={startState.migration?.url}
			/>
			
			<Radio
				name='containsProtectedContent'
				label='Does your website contain protected content?'
				onChange={(value) => setContainsProtectedContent(value === 'YES')}
				choices={[
					{
						label: 'No, nothing is protected',
						value: 'NO',
					},
					{
						label: 'Yes, but it doesn’t need to be migrated',
						value: 'IGNORE',
					},
					{
						label: 'Yes, and here’s how to access it…',
						value: 'YES',
					},
				]}
				initialValue={storybookContainsProtectedContent ? 'YES' : startState.migration?.containsProtectedContent}
			/>
			
			<AnimateHeight height={containsProtectedContent ? 'auto' : 0} duration={400} animateOpacity>
				<Textarea
					name='details'
					aria-label='How to access protected content'
					rows={4}
					placeholder='Describe how to access protected content, including any sign in credentials needed…'
					required={containsProtectedContent}
					disabled={!containsProtectedContent}
					initialValue={startState.migration?.details ?? ''}
				/>
				
				<span />
			</AnimateHeight>
		</React.Fragment>
	);
};

export default MigrateCommunity;
